import crypto from 'crypto-browserify';
const Buffer = require('buffer/').Buffer;

const _devPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmzGxXy7Koq1W/z0gf0NC
NYghIFyC7Dng2aOoES2h6PZ+R39gZDY1/LNAaLfwTLCKTiRAe83+gldR6Mxr73HE
1ujRvW9bdVcraDfEF8tmtGRKBLgITfNZCkgfHTnSP6oRjzU0iVrM8y83kgLFOqTS
mumyNHcmu6qxG1aQZ4jqDbReM0tSf6HihKuvuPzbiXXs1hw3kt3U68E4pq/eXUOk
DgYm2vEeQ8c9IvK6SxHmEVW1wYMXAFXOerIEkrBqDlC5Ok8aFlFlcUKrFlfV0XtP
q6THTB83Uao11BIANYEEwltiCgupkZTXNlnbyrix0b0B6wtVluieSBU72piPir6h
GQIDAQAB
-----END PUBLIC KEY-----
`;

const _prodPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8xkxvcY753G0ZfkeTKLo
TQFYWH3ZKO8an2+VpS7e6NZHwQ7nG2Lw8n88eCIO8ZjmYMZwoH2TqRLjaYl4fAQh
a2maEG3zxNS0vmjc0FvFJHgJRR2Wx7+1bp/Eeu1GV01Ket0KKUqA43JvU2rRDm7K
E4lh8GQkqVtJxwiVeMv3zxZ2X0LxtpSPO8HLMMZT/NoMViGkDwhs1VYtkcFXl3sD
Rzhadorf5LBCBH2WS/ZZUdM6CSvS/X8IjqRzlW2fp42PinzYBiu/knacsc4+J9KR
WEJLxrKcwjSXqouqUWMA8a61Abixqd/U6xuHCl6OqoSgnstGP/JMDtmdmz1wdJSp
vQIDAQAB
-----END PUBLIC KEY-----
`;

const _publicKeys = {
	local: _devPublicKey,
	development: _devPublicKey,
	production: _prodPublicKey
};

export function encryptCheckout(cardInformation) {
	const publicKey = _publicKeys[process.env.REACT_APP_ENV];

	const buffer = Buffer.from(JSON.stringify(cardInformation));

	const encryptedBuffer = crypto
		.publicEncrypt(publicKey, buffer)
		.toString('base64');

	return encryptedBuffer;
}
